import { ReactElement } from 'react'
import { Card } from 'react-daisyui'
import OAuthProviderButton from '@/features/Login/components/OAuthProviderButton'
import UseEmailLoginButton from '@/features/Login/components/UseEmailLoginButton'
import Footer from '@/components/Footer'
import { pointClickCareAuthProvider } from '@lib/auth/authProviders/pointClickCareAuthProvider'

const Login = (): ReactElement => {
  return (
    <div className='min-h-screen flex flex-col'>
      <div className='flex-1 flex items-center justify-center p-4'>
        <Card className='w-full max-w-md md:max-w-lg p-4 border border-grey-200 rounded-lg flex items-center shadow-md'>
          <div className='flex flex-col w-full items-center'>
            <Card.Image
              className='pt-5 pb-6 px-6 md:px-12 max-h-24 object-contain'
              src='img/curitecjpg-300x101.jpg'
              alt='Curitec logo'
            />
            <Card.Body className='w-full flex flex-col items-center space-y-2'>
              <p className='text-curitec-green font-semibold'>Select Your EMR</p>
              <div className='w-full pb-8 px-4 md:px-10'>
                <ul className='space-y-2 flex flex-col items-center'>
                  <li>
                    {/* move provider properties to config file and map over array,
                    or move to backend and jsut send backend provider name and let it build
                    the url then redirect the browser with a 303 to the url we build below in
                    the OAuthProviderButton*/}
                    <OAuthProviderButton
                      className='w-[220px] sm:w-[260px] md:w-[280px]'
                      authProvider={pointClickCareAuthProvider()}
                    >
                      PointClickCare
                    </OAuthProviderButton>
                  </li>
                  <li>
                    <UseEmailLoginButton className='w-[220px] sm:w-[260px] md:w-[280px]' />
                  </li>
                </ul>
              </div>
            </Card.Body>
          </div>
        </Card>
      </div>

      <Footer />
    </div>
  )
}

export default Login
